<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fluid class="home">
        <!-- Alumnos: -->
        <div v-if = "userType === 2">
            <v-container fluid>
                <v-row justify="center">
                    <v-btn color="grey darken-1" class="text-none" dark @click="onLogout">
                        Cerrar AOCs&nbsp;<v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-row>
                <p></p>
                <br>
                <!-- * * Video: * * * * * * * * * * * * * * * * *  -->
                <v-row justify="center">
                    <video :width="videoWidth" controls>
                        <source src="@/assets/AOCs_27oct_final.mp4">
                    </video>
                </v-row>
                <!-- * * Termina Video * * * * * * * * * * * * * * -->
                <p></p>
                <br>
                <v-row justify="center">
                    <v-btn color="#ef4044" class="text-none" dark @click="onMyAOCs">
                        Mis AOCs&nbsp;<v-icon>mdi-certificate</v-icon>
                    </v-btn>
                </v-row>
                
                <v-row>
                    <v-col cols="12">
                        <v-radio-group
                            :column="$vuetify.breakpoint.smAndDown"
                            :row="$vuetify.breakpoint.mdAndUp"
                            v-model="showAOCsByPackage"
                        >
                            <v-radio
                                label="Catálogo por paquetes"
                                value="1"
                                color="#ef4044"
                                @click="onSwitchCatalogue"
                            ></v-radio>
                            <v-radio
                                label="Catálogo por asignaturas"
                                value="0"
                                color="#ef4044"
                                @click="onSwitchCatalogue"
                            ></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                
                <!-- Los v-if deben estar un nivel arriba de los v-for para evitar problemas de índices de los
                arreglos. Para esto se ponen los v-if en templates: -->
                <template v-if="showAOCsByPackage === '1'">
                    <div  v-for="(division, i) in catalogoAOCs" :key="i">
                        <div v-if="division.numPaquetes > 0">
                            <v-divider color="#ef4044"></v-divider>
                            <p></p>
                            <v-row>
                                <v-col cols="12" class="text-left title font-weight-bold uia-red">
                                    {{ division.nombre }}
                                </v-col>
                            </v-row>
                            <v-row v-for="(departamento, j) in division.departamentos" justify="space-around">
                                <v-col cols="12" md="5" v-for="(paquete, k) in departamento.paquetes">
                                    <v-card>
                                        <v-toolbar dense color="#ef4044" dark flat>
                                            <v-toolbar-title :class="{'subtitle-1': $vuetify.breakpoint.mdAndUp, 'subtitle-2': $vuetify.breakpoint.smAndDown}">{{ departamento.nombre }}</v-toolbar-title>
                                            <v-spacer></v-spacer>
                                            <v-toolbar-items v-if="paquete.seleccionado">
                                                <v-tooltip left>
                                                    <template v-slot:activator="{ on }">
                                                        <v-icon dark color="yellow" v-on="on">
                                                            mdi-check-decagram
                                                        </v-icon>
                                                    </template>
                                                    <span>Paquete seleccionado</span>
                                                </v-tooltip>
                                            </v-toolbar-items>
                                        </v-toolbar>
                                        <v-img
                                            class="align-start my_pointer"
                                            height="250px"
                                            :src=paquete.logoFileURL
                                            gradient="to bottom, rgba(0,0,0,0.8), rgba(0,0,0,0.3)"
                                            @click="onPackageInfo(departamento.nombre, paquete)"
                                        >
                                            <v-card-text
                                            >
                                                <div class="title font-weight-medium text-left red--text text--accent-1">
                                                    {{ paquete.nombre }}
                                                </div>
                                                <v-divider class="red accent-1"></v-divider>
                                                <p></p>
                                                <div class="body-1 font-weight-regular text-left white--text">
                                                    {{ paquete.descripcion }}
                                                </div>
                                            </v-card-text>    
                                        </v-img>
                                        <v-toolbar dense color="red lighten-2" dark flat>
                                            <v-toolbar-items>
                                                <v-tooltip left>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn icon @click="onPackageInfo(departamento.nombre, paquete)" v-on="on">
                                                            <v-icon dark>
                                                                mdi-information-variant-circle-outline
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Información del paquete</span>
                                                </v-tooltip>
                                            </v-toolbar-items>
                                            <v-spacer></v-spacer>
                                            <v-toolbar-items>
                                                <v-tooltip left>
                                                    <template v-slot:activator="{ on }">
                                                        <v-btn icon @click="onSelectPackage(paquete.paqueteid, paquete.seleccionado)" v-on="on">
                                                            <v-icon dark v-if="paquete.seleccionado">
                                                                mdi-thumb-up
                                                            </v-icon>
                                                            <v-icon dark v-else>
                                                                mdi-thumb-up-outline
                                                            </v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span v-if="paquete.seleccionado">Quitar paquete</span>
                                                    <span v-else>Seleccionar paquete</span>
                                                </v-tooltip>
                                            </v-toolbar-items>
                                        </v-toolbar>
                                    </v-card>
                                </v-col>                        
                            </v-row>
                            <p></p>
                        </div>
                    </div>
                </template>
                <template v-else>
                    <v-expansion-panels class="mb-6">

                        <v-container fluid v-for="(division, x) in catalogoAOCs" :key="x">
                            <div v-if="division.numMaterias > 0 ">
                                <v-expansion-panel>
                                    <v-expansion-panel-header expand-icon="mdi-menu-down">
                                        <v-row dense>
                                        <v-col cols="12" class="text-left title font-weight-bold uia-red">
                                        {{ division.nombre }}
                                        </v-col>
                                        </v-row>
                                    </v-expansion-panel-header color="blue">
                                    
                                    <v-expansion-panel-content>
                                        <v-row v-for="(departamento) in division.departamentos" dense>
                                            <!-- Se checa si existe el arreglo materias porque la vista se va a intentar refrescar antes
                                            de que el arreglo ya exista: -->
                                            <template v-if="departamento.materias">
                                                <v-col v-if="departamento.materias.length > 1" cols="12">
                                                    <v-card elevation="5">
                                                        <v-toolbar dense color="red darken-4" dark flat>
                                                            <v-toolbar-title class="my-list-title"> {{ departamento.nombre }}</v-toolbar-title>
                                                        </v-toolbar>
                                                        <v-card-text class="pa-0">
                                                            <v-container fluid>
                                                                <v-row v-for="(materia, k) in departamento.materias" dense>
                                                                    <v-col cols="12">
                                                                        <v-card
                                                                            class="pa-3 my-course-card"
                                                                            outlined
                                                                        >
                                                                            <v-row
                                                                                v-if="$vuetify.breakpoint.smAndDown"
                                                                                justify="center"
                                                                                align="center"
                                                                                dense
                                                                            >
                                                                                <v-col cols="1">
                                                                                    <v-tooltip left>
                                                                                        <template v-slot:activator="{ on }">
                                                                                            <v-btn icon @click="onSelectCourse(materia.materiaid, materia.seleccionada)" v-on="on">
                                                                                                <v-icon v-if="materia.seleccionada" color="red darken-2">
                                                                                                    mdi-thumb-up
                                                                                                </v-icon>
                                                                                                <v-icon v-else color="red darken-2">
                                                                                                    mdi-thumb-up-outline
                                                                                                </v-icon>
                                                                                            </v-btn>
                                                                                        </template>
                                                                                        <span v-if="materia.seleccionada">Quitar materia</span>
                                                                                        <span v-else>Seleccionar materia</span>
                                                                                    </v-tooltip>
                                                                                </v-col>
                                                                                &nbsp;
                                                                                &nbsp;
                                                                                <v-col v-if="materia.seleccionada" cols="1">
                                                                                    <v-tooltip left>
                                                                                        <template v-slot:activator="{ on }">
                                                                                            <v-icon dark color="amber darken-1" v-on="on">
                                                                                                mdi-check-decagram
                                                                                            </v-icon>
                                                                                        </template>
                                                                                        <span>Materia seleccionada</span>
                                                                                    </v-tooltip>
                                                                                </v-col>
                                                                                
                                                                            </v-row>
                                                                            <v-row justify="space-between" align="center" dense>
                                                                                <v-col
                                                                                    cols="auto"
                                                                                    md="10"
                                                                                    class="d-flex justify-left font-weight-medium uia-red"
                                                                                    :class="{'subtitle-1': $vuetify.breakpoint.mdAndUp, 'subtitle-2': $vuetify.breakpoint.smAndDown}"
                                                                                    >
                                                                                        {{ materia.clave }} - {{ materia.nombre}}
                                                                                </v-col>
                                                                                <v-col v-if="$vuetify.breakpoint.mdAndUp" cols="auto">
                                                                                    <v-tooltip left>
                                                                                        <template v-slot:activator="{ on }">
                                                                                            <v-btn icon @click="onSelectCourse(materia.materiaid, materia.seleccionada)" v-on="on">
                                                                                                <v-icon color="red darken-2" v-if="materia.seleccionada">
                                                                                                    mdi-thumb-up
                                                                                                </v-icon>
                                                                                                <v-icon color="red darken-2" v-else>
                                                                                                    mdi-thumb-up-outline
                                                                                                </v-icon>
                                                                                            </v-btn>
                                                                                        </template>
                                                                                        <span v-if="materia.seleccionada">Quitar materia</span>
                                                                                        <span v-else>Seleccionar materia</span>
                                                                                    </v-tooltip>
                                                                                </v-col>
                                                                                <v-col v-if="materia.seleccionada && $vuetify.breakpoint.mdAndUp" cols="auto">
                                                                                    <v-tooltip left>
                                                                                        <template v-slot:activator="{ on }">
                                                                                            <v-icon dark color="amber darken-1" v-on="on">
                                                                                                mdi-check-decagram
                                                                                            </v-icon>
                                                                                        </template>
                                                                                        <span>Materia seleccionada</span>
                                                                                    </v-tooltip>
                                                                                </v-col>
                                                                            </v-row>
                                                                            <v-divider color="#ef4044"></v-divider>
                                                                            <br>
                                                                            <v-row dense>
                                                                                <v-col cols="12" md="4">
                                                                                    <v-textarea
                                                                                        label="Descripción"
                                                                                        v-model="materia.descripcion"
                                                                                        no-resize
                                                                                        color="red darken-1"
                                                                                        readonly
                                                                                        rows="3"
                                                                                        dense
                                                                                        outlined
                                                                                    ></v-textarea>
                                                                                </v-col>
                                                                                <v-col cols="12" md="4">
                                                                                    <v-textarea
                                                                                        label="Paquete"
                                                                                        v-model="materia.paquete"
                                                                                        no-resize
                                                                                        color="red darken-1"
                                                                                        readonly
                                                                                        rows="3"
                                                                                        dense
                                                                                        outlined
                                                                                    ></v-textarea>
                                                                                </v-col>
                                                                                <v-col cols="12" md="4">
                                                                                    <v-card>
                                                                                        <v-toolbar height="20" dark flat color="#ef4044">
                                                                                            <v-toolbar-title class="my-list-subtitle">Prerrequisitos</v-toolbar-title>
                                                                                        </v-toolbar>
                                                                                        <v-list
                                                                                            subheader
                                                                                            dense
                                                                                            :height="prerreqListHeight"
                                                                                            max-height="100%"
                                                                                            class="overflow-y-auto"
                                                                                            outlined
                                                                                            flat
                                                                                        >
                                                                                            <v-list-item
                                                                                                class="my-list-item"
                                                                                                v-for="(prerreq, j) in materia.prerrequisitos"
                                                                                                :key="j"
                                                                                            >
                                                                                                <v-list-item-content>
                                                                                                    <v-list-item-title>
                                                                                                        {{ prerreq.clave }} - {{ prerreq.materia }}
                                                                                                    </v-list-item-title>
                                                                                                </v-list-item-content>
                                                                                            </v-list-item>
                                                                                        </v-list>
                                                                                    </v-card>
                                                                                </v-col>
                                                                            </v-row>
                                                                        </v-card>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-container>
                                                            
                                                        </v-card-text>
                                                    </v-card>
                                                </v-col>
                                            </template>                      
                                        </v-row>
                                    </v-expansion-panel-content>
                            
                                </v-expansion-panel>
                            </div>
                        </v-container>

                    </v-expansion-panels>
                </template>

                <v-row v-if="showPackageInfoDlg">
                    <v-dialog v-model="showPackageInfoDlg" persistent width="90%">
                        <Package-Info :package="selectedPackage"></Package-Info>
                    </v-dialog>
                </v-row>

                <v-row v-if="myAOCsDlg">
                    <v-dialog v-model="myAOCsDlg" persistent width="90%">
                        <Mis-AOCs :showAOCsByPackage="showAOCsByPackage"></Mis-AOCs>
                    </v-dialog>
                </v-row> 

            </v-container>
        </div>
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from 'vuex';
import PackageInfo from '@/components/PackageInfo';
import MisAOCs from '@/components/MisAOCs';

export default {
    name: 'home',
    data() {
        return {
            bDense: true,
            errorMessage: '',
            updateTerms: 0, //Para forzar a que se redibujen los semestres cuando se cambia el orden de una materia.
            selectedEnfoque: '',
            courseID: 0,
            termID: 0,
            
            
            semestreID: 0,

            searchText: '',
            selectedCatalogueCourseName: '',
            nombreMateria: '',
            clave: '',
            sigla: '',
            creditos: 0,
            horas: 0,
            semestreIdeal: 0,
            obligatoria: false,
            area: '',
            secuencia: '',
            opcion: '',

            materiasPorAsignar: [], //Materias que el alumno no ha agregado a su plan.

            courseHeader: [
                {
                    text: 'Clave',
                    value: 'clave',
                    sortable: true,
                    width: '10%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Asignatura',
                    value: 'nombre',
                    sortable: true,
                    width: '20%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Descripción',
                    value: 'descripcion',
                    sortable: false,
                    width: '40%',
                    align: 'left',
                    divider: true,
                },
                {
                    text: 'Paquete',
                    value: 'paquete',
                    sortable: true,
                    width: '30%',
                    align: 'left',
                    divider: true,
                },
                // {
                //     text: 'Prerrequisitos',
                //     value: 'prerrequisitos',
                //     sortable: true,
                //     width: '20%',
                //     align: 'left',
                //     divider: true,
                // },
            ],
            selectedCourses: [],


            headerSeqOptions: [],

            
            seasons: [
                {
                    termID: 1,
                    term: 'Primavera'
                },
                {
                    termID: 2,
                    term: 'Verano'
                },
                {
                    termID: 3,
                    term: 'Otoño'
                }
            ],

            headerConfigTerms: [
                {
                    text: 'Semestre',
                    value: 'semestre',
                    align: 'center',
                    sortable: false,

                },
                {
                    text: 'Periodo',
                    value: 'periodo',
                    align: 'center',
                    sortable: false,
                },
            ],

            tempSemestres: [], //Para agregar/borrar semestres.
            selectedTerm: [],
            years: [],
            bWarningDeleteTermsDlg: false,

            bDlgPrerreqWarning: false,
            bDlgSummerWarning: false, //Indica que la materia que se desea agregar no se abre en verano.
            summerWarningTxt: "",
            bDlgCourseFoundLater: false,
            strCourseFoundLater: '',

            selectedPackage: null,
            packageID: 0,
        };
    },

    created() {
        //console.log("Home created, userID = ", this.userID);
        //console.log("Home created, materias plan = ", this.materiasPlan);
        this.showAOCsByPackage = '1'; //Por default se comienza mostrando el catálogo por paquetes.
    },

    components:
    {
        PackageInfo, MisAOCs,
    },

    methods: {

        onClickDivision(x)
        {
            this.catalogoAOCs[x].show = !this.catalogoAOCs[x].show;
            this.$forceUpdate();
        },

        onSwitchCatalogue(){
            //console.log("showAOCsByPackate = ", this.showAOCsByPackage);
            if (this.showAOCsByPackage === '1')
            {
                //console.log("Catálogo por paquete...");
                this.$store.dispatch('fetchCatalogoPorPaquete');
            }
            else
            {
                //console.log("Catálogo por asignatura...");
            this.$store.dispatch('fetchCatalogoPorAsignatura');
            }
        },

        onSelectPackage(packageID, bSelected)
        {
            //Si el paquete esaba seleccionado, se desselecciona:
            if (bSelected)
            {
                for (let i = 0; i < this.userAOCs.paquetes.length; i ++)
                {
                    if (this.userAOCs.paquetes[i].paqueteid === packageID)
                    {
                        this.userAOCs.paquetes.splice(i, 1);
                        break;
                    }
                }

                //El paquete se pone como no seleccionado en el catálogo de paquetes:

                var bPaqueteEncontrado = false;
                //console.log("catalogoAOCs = ", this.catalogoAOCs);
                for (let i = 0; i < this.catalogoAOCs.length; i ++)
                {
                    for (let j = 0; j < this.catalogoAOCs[i].departamentos.length; j ++)
                    {
                        for (let k = 0; k < this.catalogoAOCs[i].departamentos[j].paquetes.length; k ++)
                        {
                            if (this.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid === packageID)
                            {
                                this.catalogoAOCs[i].departamentos[j].paquetes[k].seleccionado = false;
                                bPaqueteEncontrado = true;
                                break;
                            }
                        }
                        /*if (bPaqueteEncontrado)
                        {
                            break;
                        }*/
                    }
                    /*if (bPaqueteEncontrado)
                    {
                        break;
                    }*/
                }

                //console.log("userAOCs = ", this.userAOCs);
                
                //Se elimina el paquete de la BD:
                this.$store.dispatch('unselectPackage', packageID);
            }
            else //El paquete no estaba seleccionado, por lo que se selecciona:
            {
                //Se crea un elemento en userAOCs:
                const paquete = {
                    paqueteid: packageID,
                };

                this.userAOCs.paquetes.push(paquete);

                //El paquete se pone como seleccionado en el catálogo de paquetes:

                var bPaqueteEncontrado = false;
                for (let i = 0; i < this.catalogoAOCs.length; i ++)
                {
                    for (let j = 0; j < this.catalogoAOCs[i].departamentos.length; j ++)
                    {
                        for (let k = 0; k < this.catalogoAOCs[i].departamentos[j].paquetes.length; k ++)
                        {
                            if (this.catalogoAOCs[i].departamentos[j].paquetes[k].paqueteid === packageID)
                            {
                                this.catalogoAOCs[i].departamentos[j].paquetes[k].seleccionado = true;
                                bPaqueteEncontrado = true;
                                console.log("Paquete encontrado...");
                                break;
                            }
                        }
                        /*if (bPaqueteEncontrado)
                        {
                            break;
                        }*/
                    }
                    /*if (bPaqueteEncontrado)
                    {
                        break;
                    }*/
                }

                //console.log("userAOCs = ", this.userAOCs);

                //Se agrega el paquete a la BD:
                this.$store.dispatch('selectPackage', packageID);
            }
        },

        onSelectCourse(courseID, bSelected)
        {
            //Si la materia esaba seleccionado, se desselecciona:
            if (bSelected)
            {
                for (let i = 0; i < this.userAOCs.materias.length; i ++)
                {
                    if (this.userAOCs.materias[i].materiaid === courseID)
                    {
                        this.userAOCs.materias.splice(i, 1);
                        break;
                    }
                }

                //La materia se pone como no seleccionada en el catálogo de paquetes:

                var bMateriaEncontrada = false;
                //console.log("catalogoAOCS = ", this.catalogoAOCs);
                for (let i = 0; i < this.catalogoAOCs.length; i ++)
                {
                    for (let j = 0; j < this.catalogoAOCs[i].departamentos.length; j ++)
                    {
                        for (let k = 0; k < this.catalogoAOCs[i].departamentos[j].materias.length; k ++)
                        {
                            if (this.catalogoAOCs[i].departamentos[j].materias[k].materiaid === courseID)
                            {
                                this.catalogoAOCs[i].departamentos[j].materias[k].seleccionada = false;
                                bMateriaEncontrada = true;
                                break;
                            }
                        }
                        if (bMateriaEncontrada)
                        {
                            break;
                        }
                    }
                    if (bMateriaEncontrada)
                    {
                        break;
                    }
                }

                //console.log("userAOCs = ", this.userAOCs);
                
                //Se elimina la materia de la BD:
                this.$store.dispatch('unselectCourse', courseID);
            }
            else //La materia no estaba seleccionada, por lo que se selecciona:
            {
                //Se crea un elemento en userAOCs:
                const materia = {
                    materiaid: courseID,
                };

                this.userAOCs.materias.push(materia);

                //La materia se pone como seleccionado en el catálogo de materias:

                var bMateriaEncontrada = false;
                for (let i = 0; i < this.catalogoAOCs.length; i ++)
                {
                    for (let j = 0; j < this.catalogoAOCs[i].departamentos.length; j ++)
                    {
                        for (let k = 0; k < this.catalogoAOCs[i].departamentos[j].materias.length; k ++)
                        {
                            if (this.catalogoAOCs[i].departamentos[j].materias[k].materiaid === courseID)
                            {
                                this.catalogoAOCs[i].departamentos[j].materias[k].seleccionada = true;
                                bMateriaEncontrada = true;
                                break;
                            }
                        }
                        if (bMateriaEncontrada)
                        {
                            break;
                        }
                    }
                    if (bMateriaEncontrada)
                    {
                        break;
                    }
                }

                //console.log("userAOCs = ", this.userAOCs);

                //Se agrega la materia a la BD:
                this.$store.dispatch('selectCourse', courseID);
                this.$forceUpdate();
            }
        },

        onPackageInfo(departamento, paquete)
        {
            this.packageID = paquete.paqueteid;
            //Agrega el nombre del departamento al objeto del paquete:
            this.selectedPackage = {
                paqueteid: paquete.paqueteid,
                nombre: paquete.nombre,
                descripcion: paquete.descripcion,
                logoFileURL: paquete.logoFileURL,
                seleccionado: paquete.seleccionado,
                departamento: departamento,
            };
            this.showPackageInfoDlg = true;
        },

        onMyAOCs()
        {
            this.myAOCsDlg = true;
        },

        onLogout() {
            this.$store.dispatch('studentLogout');
        },

    },

    mounted(){
        
    },

    computed: {
        ...mapGetters([
            'waitCursor',
            'isAuthenticated',
            'version',
            'userType',
            'userID',
            'planesEstudios',
            'planEstudios',
            'materiasPlan',
            'materia',
        ]),

        showAOCsByPackage: {
            get() {
                return this.$store.getters.showAOCsByPackage;
            },
            set(showAOCsByPackage) {
                this.$store.dispatch('updateShowAOCsByPackage', showAOCsByPackage);
            },
        },

        loadingData: {
            get() {
                return this.$store.getters.loadingData;
            },
            set(loadingData) {
                this.$store.dispatch('updateLoadingData', loadingData);
            },
        },

        materiaLoaded: {
            get() {
                return this.$store.getters.materiaLoaded;
            },
            set(materiaLoaded) {
                this.$store.dispatch('updateMateriaLoaded', materiaLoaded);
            },
        },

        courseListHeight() {
            var height = this.$vuetify.breakpoint.height;
            var listHeigth;
            
            if (height < 400)
            {
                listHeigth = height/1.65;
            }
            else
            {
                listHeigth = height/1.4;
            }
            //console.log("Course list height = ", listHeigth);

            return listHeigth;
        },

        courseDlgHeight() {
            var height = this.$vuetify.breakpoint.height;
            var dlgHeight;

            if (height < 400)
            {
                dlgHeight = height/1.65 + 100;
            }
            else
            {
                dlgHeight = height/1.4 + 100;
            }

            //console.log("Height = ", this.$vuetify.breakpoint.height);
            //console.log("Course dlg height = ", height);

            return dlgHeight;
        },

        term1DlgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '98%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else {
                width = '30%';
            }
            return width;
        },

        configTermsDlgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '95%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else {
                width = '35%';
            }
            return width;
        },

        warningWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '100%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '60%';
            } else {
                width = '40%';
            }
            return width;
        },

        sequenceOptionsDlgWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '100%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '90%';
            } else {
                width = '70%';
            }
            return width;
        },

        prerreqListHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '60px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '100px';
            } else {
                height = '70px';
            }
            return height;
        },

        videoWidth() {
            var width;
            if (this.$vuetify.breakpoint.xs) {
                width = '100%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '70%';
            } else {
                width = '50%';
            }
            return width;
        },

        semestres:
        {
            get() {
                return this.$store.getters.semestres;
            },
            set(semestres) {
                this.$store.dispatch( 'updateSemestres', semestres);
            },
        },

        showSequenceOptionsDlg: {
            get() {
                return this.$store.getters.showSequenceOptionsDlg;
            },
            set(showSequenceOptionsDlg) {
                this.$store.dispatch('updateShowSequenceOptionsDlg', showSequenceOptionsDlg);
            },
        },

        sequenceOptionID: {
            get() {
                return this.$store.getters.sequenceOptionID;
            },
            set(sequenceOptionID) {
                this.$store.dispatch('updateSequenceOptionID', sequenceOptionID);
            },
        },

        opcionesSecuenciaTitle(){
            var nombreSecuencia = "";
            for (let i = 0; i < this.opcionesSecuencia.length; i ++)
            {
                if (this.opcionesSecuencia[i].secuenciaid === this.sequenceOptionID)
                {
                    nombreSecuencia = this.opcionesSecuencia[i].nombreSecuencia;
                    break;
                }
            }
            return nombreSecuencia;
        },

        opcionesSecuencia(){
            var secuenciasAlumno = [];

            if ((this.planEstudios !== null) && (this.planesEstudios !== undefined) && (this.semestres !== undefined))
            {
                if (this.planEstudios.secuenciasFormativas !== undefined)
                {
                    for (let i = 0; i < this.planEstudios.secuenciasFormativas.length; i ++)
                    {
                        var secuencia = {
                            secuenciaid: this.planEstudios.secuenciasFormativas[i].secuenciaid,
                            nombreSecuencia: this.planEstudios.secuenciasFormativas[i].secuencia,
                            opcionesSec: [],
                            materiasObligatorias: this.planEstudios.secuenciasFormativas[i].materiasObligatorias,
                            materiasOptativas: this.planEstudios.secuenciasFormativas[i].materiasOptativas
                        };

                        //Busca si en el plan del alumno hay materias de esta secuencia formativa:
                        for (let j = 0; j < this.semestres.length; j ++)
                        {
                            for (let k = 0; k < this.semestres[j].materias.length; k ++)
                            {
                                if (this.semestres[j].materias[k].secuenciaFormativaid === this.planEstudios.secuenciasFormativas[i].secuenciaid)
                                {
                                    //La materia es de la secuencia formativa. Se checa si es obligatoria u optativa:
                                    var obligEnPlan = 0;  //Materias obligatorias en plan, hayan sido cursadas o no, pero no reprobadas.
                                    var obligAprobadas = 0; //Materias obligatorias en plan que ya fueron aprobadas.
                                    var optEnPlan = 0;    //Materias optativas en plan, hayan sido cursadas o no, pero no reprobadas.
                                    var optAprobadas = 0;   //Materias optativas en plan que ya fueron aprobadas.
                                    if (this.semestres[j].materias[k].obligatoria)
                                    {
                                        //Si la materia está agendada, se está cursando o ya fue aprobada, se incrementa el número de materias agendadas:
                                        if ((this.semestres[j].materias[k].status === 1) || (this.semestres[j].materias[k].status === 2) || (this.semestres[j].materias[k].status === 3))
                                        {
                                            obligEnPlan = 1;

                                            //Si la materia ya fue aprobada, se incrementa el número de materias aprobadas:
                                            if (this.semestres[j].materias[k].status === 3)
                                            {
                                                obligAprobadas = 1;
                                            }
                                        }
                                    }
                                    else
                                    {
                                        //Si la materia está agendada, se está cursando o ya fue aprobada, se incrementa el número de materias programadas:
                                        if ((this.semestres[j].materias[k].status === 1) || (this.semestres[j].materias[k].status === 2) || (this.semestres[j].materias[k].status === 3))
                                        {
                                            optEnPlan = 1;

                                            //Si la materia ya fue aprobada, se incrementa el número de materias aprobadas:
                                            if (this.semestres[j].materias[k].status === 3)
                                            {
                                                optAprobadas = 1;
                                            }
                                        }
                                    }

                                    //Checa si ya se había agregado otra materia de la misma opción a esta secuencia:
                                    var bFound = false;
                                    for (let x = 0; x < secuencia.opcionesSec.length; x ++)
                                    {
                                        if (secuencia.opcionesSec[x].opcionid === this.semestres[j].materias[k].opcionid)
                                        {
                                            //Ya se había agregado una materia de esta opción...
                                            secuencia.opcionesSec[x].obligatoriasEnPlan += obligEnPlan;
                                            secuencia.opcionesSec[x].obligatoriasAprobadas += obligAprobadas;
                                            secuencia.opcionesSec[x].obligatoriasFaltantesEnPlan -= obligEnPlan;
                                            secuencia.opcionesSec[x].obligatoriasFaltantesPorAprobar -= obligAprobadas;

                                            secuencia.opcionesSec[x].optativasEnPlan += optEnPlan;
                                            secuencia.opcionesSec[x].optativasAprobadas += optAprobadas;
                                            secuencia.opcionesSec[x].optativasFaltantesEnPlan -= optEnPlan;
                                            secuencia.opcionesSec[x].optativasFaltantesPorAprobar -= optAprobadas;

                                            bFound = true;
                                            break;
                                        }
                                    }
                                    if (!bFound)
                                    {
                                        //No se había agregado ninguna materia de esta opción todavía...
                                        //console.log("planEstudios.secuenciasFormativas[i] = ", this.planEstudios.secuenciasFormativas[i]);
                                        var opcion = {
                                            opcionid: this.semestres[j].materias[k].opcionid,
                                            opcion: this.semestres[j].materias[k].opcion,

                                            obligatorias: this.planEstudios.secuenciasFormativas[i].materiasObligatorias,
                                            obligatoriasEnPlan: obligEnPlan,
                                            obligatoriasAprobadas: obligAprobadas,
                                            obligatoriasFaltantesEnPlan: this.planEstudios.secuenciasFormativas[i].materiasObligatorias - obligEnPlan,
                                            obligatoriasFaltantesPorAprobar: this.planEstudios.secuenciasFormativas[i].materiasObligatorias - obligAprobadas,

                                            optativas: this.planEstudios.secuenciasFormativas[i].materiasOptativas,
                                            optativasEnPlan: optEnPlan,
                                            optativasAprobadas: optAprobadas,
                                            optativasFaltantesEnPlan: this.planEstudios.secuenciasFormativas[i].materiasOptativas - optEnPlan,
                                            optativasFaltantesPorAprobar: this.planEstudios.secuenciasFormativas[i].materiasOptativas - optAprobadas,
                                        }
                                        secuencia.opcionesSec.push(opcion);
                                    }
                                }
                            }
                        }

                        if (secuencia.opcionesSec.length === 0)
                        {
                            //Si no se ha registrado ninguna materia de ninguna opción, se crea un elemento para el arreglo en donde se pueda
                            //ver que no hay materias todavía:
                            var opcion = {
                                opcionid: 0,
                                opcion: "",
                                
                                obligatorias: this.planEstudios.secuenciasFormativas[i].materiasObligatorias,
                                obligatoriasEnPlan: 0,
                                obligatoriasAprobadas: 0,
                                obligatoriasFaltantesEnPlan: this.planEstudios.secuenciasFormativas[i].materiasObligatorias,
                                obligatoriasFaltantesPorAprobar: this.planEstudios.secuenciasFormativas[i].materiasObligatorias,

                                optativas: this.planEstudios.secuenciasFormativas[i].materiasOptativas,
                                optativasEnPlan: 0,
                                optativasAprobadas: 0,
                                optativasFaltantesEnPlan: this.planEstudios.secuenciasFormativas[i].materiasOptativas,
                                optativasFaltantesPorAprobar: this.planEstudios.secuenciasFormativas[i].materiasOptativas,
                            }
                            secuencia.opcionesSec.push(opcion);
                        }
                        secuenciasAlumno.push(secuencia);
                    }
                }
            }
            //console.log("secuenciasAlumno = ", secuenciasAlumno);
            return secuenciasAlumno;
        },

        optionsSelectedSeq()
        {
            //Regresa la secuencia formativa seleccionada en el menú:
            var selectedSeq = [];

            for (let i = 0; i < this.opcionesSecuencia.length; i ++)
            {
                if (this.opcionesSecuencia[i].secuenciaid === this.sequenceOptionID)
                {
                    selectedSeq = this.opcionesSecuencia[i].opcionesSec;
                    break;
                }
            }
            return selectedSeq;
        },

        bAllowDeleteTerm()
        {
            //Sólo se permite borrar el último semestre, siempre y cuando este semestre no sea también el primero:

            var bAllowDelete = false;

            if (this.selectedTerm.length > 0)
            {
                //Si no es el primero y si no es verano...
                if ((this.selectedTerm[0].periodo !== this.tempSemestres[0].periodo) &&(this.selectedTerm[0].tipoPeriodoID !== 2))
                {
                    //Si el semestre seleccionado es el último, sí permite borrarlo:
                    if (this.selectedTerm[0].periodo === this.tempSemestres[this.tempSemestres.length - 1].periodo)
                    {
                        bAllowDelete = true;
                    }
                }
            }
            return bAllowDelete;
        },

        bAllowAddSummer()
        {
            //Sólo se permite agregar un verano si el elemento seleccionado es primavera y no hay todavía un verano después:

            var bAllowSummer = false;

            if (this.selectedTerm.length > 0)
            {
                if (this.selectedTerm[0].tipoPeriodoID === 1)//El semestre seleccionado es primavera...
                {
                    for (let i = 0; i < this.tempSemestres.length; i ++)
                    {
                        if (this.tempSemestres[i].semestreid === this.selectedTerm[0].semestreid)
                        {
                            if (i === this.tempSemestres.length - 1)//El semestre seleccionado es el último...
                            {
                                bAllowSummer = true;
                                break;
                            }
                            else //El semestre seleccionado no es el último...
                            if (this.tempSemestres[i + 1].tipoPeriodoID !== 2)//Si el siguiente semestre no es verano
                            {
                                bAllowSummer = true;
                                break;
                            }
                        }
                    }
                }
            }
            return bAllowSummer;
        },

        bAllowDeleteSummer()
        {
            var bAllowDelete = false;

            if (this.selectedTerm.length > 0)
            {
                //Si no es el primero y sí es verano...
                if ((this.selectedTerm[0].periodo !== this.tempSemestres[0].periodo) &&(this.selectedTerm[0].tipoPeriodoID === 2))
                {
                     bAllowDelete = true;
                }
            }
            return bAllowDelete;
        },

        catalogoAOCs: {
            get() {
                return this.$store.getters.catalogoAOCs;
            },
            set(catalogoAOCs) {
                this.$store.dispatch('updateCatalogoAOCs', catalogoAOCs)
            },
        },

        userAOCs: {
            get() {
                return this.$store.getters.userAOCs;
            },
            set(userAOCs) {
                this.$store.dispatch('updateUserAOCs', userAOCs)
            },
        },

        showPackageInfoDlg: {
            get() {
                return this.$store.getters.showPackageInfoDlg;
            },
            set(showPackageInfoDlg) {
                this.$store.dispatch('updateShowPackageInfoDlg', showPackageInfoDlg)
            },
        },

        forceRedraw: {
            get() {
                return this.$store.getters.forceRedraw;
            },
            set(forceRedraw) {
                this.$store.dispatch('updateForceRedraw', forceRedraw)
            },
        },

        myAOCsDlg: {
            get() {
                return this.$store.getters.myAOCsDlg;
            },
            set(myAOCsDlg) {
                this.$store.dispatch('updateMyAOCsDlg', myAOCsDlg)
            },
        },
    },

    watch: {
        showSequenceOptionsDlg: function(value, oldValue){
            if (this.showSequenceOptionsDlg)
            {
                this.headerSeqOptions = [
                {
                    text: 'Opción',
                    value: 'opcion',
                    align: 'left',
                    sortable: false
                }];

                if (this.optionsSelectedSeq[0].obligatorias !== 0)
                {
                    var columnOblig = {
                        text: 'Obligatorias',
                        value: 'obligatorias',
                        align: 'center',
                        sortable: false
                    };
                    this.headerSeqOptions.push(columnOblig);

                    var columnObligAgendadas = {
                        text: 'Obligatorias agendadas',
                        value: 'obligatoriasEnPlan',
                        align: 'center',
                        sortable: false
                    };
                    this.headerSeqOptions.push(columnObligAgendadas);

                    var columnObligPorAgendar = {
                        text: 'Obligatorias faltantes por agendar',
                        value: 'obligatoriasFaltantesEnPlan',
                        align: 'center',
                        sortable: false
                    };
                    this.headerSeqOptions.push(columnObligPorAgendar);

                    var columnObligAprobadas = {
                        text: 'Obligatorias aprobadas',
                        value: 'obligatoriasAprobadas',
                        align: 'center',
                        sortable: false
                    };
                    this.headerSeqOptions.push(columnObligAprobadas);

                     var columnObligPorAprobar = {
                        text: 'Obligatorias por aprobar',
                        value: 'obligatoriasFaltantesPorAprobar',
                        align: 'center',
                        sortable: false
                    };
                    this.headerSeqOptions.push(columnObligPorAprobar);
                }

                if (this.optionsSelectedSeq[0].optativas !== 0)
                {
                    var columnOpt = {
                        text: 'Optativas',
                        value: 'optativas',
                        align: 'center',
                        sortable: false,
                    };
                    this.headerSeqOptions.push(columnOpt);

                    var columnOptAgendadas = {
                        text: 'Optativas agendadas',
                        value: 'optativasEnPlan',
                        align: 'center',
                        sortable: false,
                    };
                    this.headerSeqOptions.push(columnOptAgendadas);

                    var columnOptPorAgendar = {
                        text: 'Optativas faltantes por agendar',
                        value: 'optativasFaltantesEnPlan',
                        align: 'center',
                        sortable: false,
                    };
                    this.headerSeqOptions.push(columnOptPorAgendar);

                    var columnOptAprobadas = {
                        text: 'Optativas aprobadas',
                        value: 'optativasAprobadas',
                        align: 'center',
                        sortable: false,
                    };
                    this.headerSeqOptions.push(columnOptAprobadas);

                    var columnOptPorAprobar = {
                        text: 'Optativas por aprobar',
                        value: 'optativasFaltantesPorAprobar',
                        align: 'center',
                        sortable: false,
                    };
                    this.headerSeqOptions.push(columnOptPorAprobar);
                }
            }
        },

        materiaLoaded: function(value, oldValue)
        {
            if (this.materiaLoaded)
            {
                this.nombreMateria = this.materia.materia;
                this.clave = this.materia.clave;
                this.sigla = this.materia.sigla;
                this.creditosMateria = this.materia.creditos;
                this.horas = this.materia.horas;
                this.semestreIdeal = this.materia.semestreIdeal;
                this.obligatoria = this.materia.obligatoria;

                this.area = '';
                for (let i = 0; i < this.areas.length; i ++)
                {
                    if (this.areas[i].areaid === this.materia.areaid)
                    {
                        this.area = this.areas[i].area;
                        break;
                    }
                }

                for (let i = 0; i < this.planEstudios.secuenciasFormativas.length; i ++)
                {
                    if (this.planEstudios.secuenciasFormativas[i].secuenciaid === this.materia.secuenciaFormativaid)
                    {
                        this.secuencia = this.planEstudios.secuenciasFormativas[i].secuencia;
                        for (let j = 0; j < this.planEstudios.secuenciasFormativas[i].opciones.length; j ++)
                        {
                            if (this.planEstudios.secuenciasFormativas[i].opciones[j].opcionid === this.materia.opcionid)
                            {
                                this.opcion = this.planEstudios.secuenciasFormativas[i].opciones[j].opcion;
                                break;
                            }
                        }
                        break;
                    }
                }

                this.selectedCatalogueCourseName = this.nombreMateria;

                this.materiaLoaded = false;
            }
        },

        forceRedraw: function(value, oldValue){
            if (this.forceRedraw)
            {
                this.forceRedraw = false;
                this.$forceUpdate();
            }
        },
    },
};
</script>



<style scoped>
.home {
    /* background: url('../assets/patiogallo2.jpg'); */
    /* background-color: #bdbdbd; */
    /* background-color: #ffebee; */
    background-color: white;
    background-size: cover;
    width: 100%;
    height: 100%;
    
}
.sub-window {
    /* background: rgba(89, 111, 133, 0.7); */
    background: rgba(0, 0, 0, 0.7);
    /* background: rgba(255, 255, 255, 0.5); */
}

.uia-red {
    color:#ef4044!important;
}

.my-course-card
{
    border-width: 10px;
    border-color: #BDBDBD!important;
}

.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}

.login-section {
    background: rgba(238, 238, 238, 0.85);
}

.descripcion_materia {
    /* font-size: 0.9em;*/
    line-height: 14px;
    font-size: 12px;
}

.my_black_text {
    color: black;
}

.my-list-title {
    font-size: 13px;
    font-weight: bold;
}

.semestre_actual {
    background-color: rgba(255, 0, 0, 0.2);
    border-radius: 50px;
}

.semestre_no_actual {
    background-color: rgba(150, 150, 150, 0.8);
    /* background-color: rgba(74, 20, 140, 0.4); */
    border-radius: 50px;
}

.nested {
    display: inline-block;
    vertical-align: top;
}

.prerreq {
    list-style-type: none;
    padding-left: 0;
    list-style-position: inside;
    text-indent: -1em;
    padding-left: 1em;
    
}

.my_pointer {
    cursor: pointer;
}


/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>
